import { ExclamationMarkCircleIcon } from '../../../../../icons';

export enum BANNER_TYPE {
  SUBSCRIPTION_CREATED = 'SUBSCRIPTION_CREATED',
}

export const Banners = ({ type }: { type: BANNER_TYPE }) => {
  switch (type) {
    default:
    case BANNER_TYPE.SUBSCRIPTION_CREATED:
      return (
        <>
          <div className="mb-2 flex flex-row items-start gap-x-3 rounded-lg border border-blue-5 bg-blue-1 px-5 py-3">
            <ExclamationMarkCircleIcon className="fill-blue-5" width={24} height={24} />
            <div className="flex flex-col items-start gap-y-1 text-blue-5">
              <h2 className="text-start text-base font-semibold leading-tight">
                Your Cluey+ subscription is being created
              </h2>
              <p className="text-sm">Your details will be updated when the subscription is ready</p>
            </div>
          </div>
        </>
      );
  }
};
